'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.getTimeUTC = getTimeUTC;
exports.epoch = epoch;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/prefer-default-export */

var TIMESERVER = 'https://utils.api.forthepeople.com/v1/time';

/**
 * get the current UTC time from an authoritative time server. The server must return a key, `iso_time`, in the response
 * body
 * @return Promise resolving with the current UTC time in ISO format
 */
function getTimeUTC() {
    return new _promise2.default(function (resolve, reject) {
        $.get(TIMESERVER).then(function (resp) {
            return resolve(resp.iso_time);
        }).fail(reject);
    });
}

/**
 * get the seconds since the epoch for the given Date (defaults to current date)
 * @param dt @Date
 */
function epoch(dt) {
    var date = dt || new Date();
    return date.getTime() / 1000;
}


//////////////////
// WEBPACK FOOTER
// ./~/@morgan-morgan/core/module/lib/time.js
// module id = 189
// module chunks = 2 3